<template>
    <div class="body-panel dataContent">
        <template v-if="news != null">
            <div class="body-panel-control separator">
                <div class="control-block-left">
                    <div class="flex">
                        <p class="btn-back">
                            <router-link to="/news">Назад</router-link>
                        </p>
                    </div>
                </div>
                <div class="control-block-right">
                    <div class="btns flex">
                        <button type="button" class="btn" @click="onEditNews()" v-if="info.User && (hasClaims(info.User.DynamicRole, claimEnums.newsCreate) || info.User.MainRole === 'administrators')">Редактировать</button>
                    </div>
                </div>
            </div>
            <div class="body-panel-content body-panel-content-page">
                <div class="body-panel page-content-block">
                    <p class="news-header">{{ news.Title }}</p>
                    <p class="caption-help margin-top-5">{{ news.StartDate | date-short }}</p>
                    <div class="margin-top-30 fr-view" v-html="BodyFormatted"></div>

                    <div class="margin-top-20" v-if="news.YoutubeLink">
                        <iframe class="youtube" width="560" height="315" :src="news.YoutubeLink" frameborder="0" allow="autoplay;encrypted-media" allowfullscreen></iframe>
                    </div>
                    <div class="flex margin-top-30">
                        <div class="flex news-stats" v-if="news.LikesEnabled || news.CommentsEnabled || news.DisplayViews">
                            <div class="flex" @click.stop="onShowUsers">
                                <div v-if="news.LikesEnabled"  :class="['news-actions like', {'bold': news.MyVote === true}]"
                                     @click.stop="onMakeMark()" @mouseenter="onMarkEnter" @mouseleave="onMarkLeave">
                                    <svg class="svg-icon like-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <use xlink:href="/Content/dist/image_svg.svg#Like"></use>
                                    </svg>
                                    <svg class="svg-icon like-2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <use xlink:href="/Content/dist/image_svg.svg#Like2"></use>
                                    </svg>
                                    <span>{{news.LikesCount}}</span>

                                    <transition name="fade">
                                        <div class="tooltip" v-if="showWhoLiked">
                                            <div class="tooltip-header">
                                                Понравилось {{news.LikesCount}} {{ get_text_ending(news.LikesCount, ['человеку','людям','людям']) }}
                                            </div>
                                            <div class="tooltip-body">
                                                <img v-for="user of news.LastLikedUsers" :class="['like-user', {'u57': !user.Image}]"
                                                     :src="user.Image ? (user.Image) : '/Content/dist/u57.png'" />
                                            </div>
                                        </div>
                                    </transition>
                                </div>
                                <div class="news-actions margin-left-15" v-if="news.DisplayViews" title="Всего просмотров">
                                    <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <use xlink:href="/Content/dist/image_svg.svg#Eye"></use>
                                    </svg>
                                    <span>{{news.ViewsCount}}</span>
                                </div>
                            </div>
                            <div class="news-actions margin-left-15" v-if="news.CommentsEnabled" title="Всего комментариев">
                                <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <use xlink:href="/Content/dist/image_svg.svg#Comm"></use>
                                </svg>
                                <span>{{news.CommentsCount}}</span>
                            </div>
                        </div>
                        <div class="margin-left-15">
                            <button type="button" class="btn" @click="onShowComments()" v-if="news.CommentsEnabled">Обсудить</button>
                        </div>
                    </div>
                </div>
            </div>
            <div id="Comments" class="body-panel-pp-right body-panel" v-if="news.CommentsEnabled" :style="commentShow ? 'margin-right: 0' : ''">
                <div data-v-72fb03bf="" class="popup-close" @click="onShowComments()"></div>
                <div id="CommentsBody" class="body-panel-content"  @scroll="onScrollComments">
                    <div class="comments">
                        <div class="caption-help" v-if="comments.data.length === 0" style="text-align:center;margin-top:150px;font-size:18px;padding:0 80px;white-space:normal">
                            Напишите первым сообщение к этой новости!
                        </div>
                        <div v-for="(comment, c) of comments.data" :class="['comment', {'comment-deleted': comment.Deleted === true}]">
                            <div class="flex">
                                <div class="user-icon">
                                    <svg v-if="comment.UserImage == null" class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <use xlink:href="/Content/dist/image_svg.svg?#User"></use>
                                    </svg>
                                    <img v-else :src="comment.UserImage" />
                                </div>
                                <div>
                                    <p class="comment-author">{{comment.UserFio}}</p>
                                    <span class="caption-help margin-top-10">{{formatDate(comment.CreateDate, 'DD.MM.YYYY HH:mm')}}</span>
                                </div>
                            </div>
                            <div class="comment-info margin-top-5">
                                <span class="caption-help" v-if="comment.EditedByAdminDate && (comment.UserId === info.User.Id || info.User.MainRole === 'administrators')">(Изменен администратором: {{formatDate(comment.EditedByAdminDate, 'DD.MM.YYYY HH:mm')}})</span>

                                <template v-if="!comment.Edited">
                                    <p v-html="formatBody(comment.Body)"></p>
                                    <p v-if="comment.Deleted === true">
                                        (Комментарий удалён<template v-if="comment.DeletedByAdmin === true"> администратором</template>)
                                    </p>
                                </template>
                                <template v-else>
                                    <textarea :name="'commentBody' + c"
                                              data-vv-scope="editForm"
                                              v-validate="'required'"
                                              v-model="comment.Body"
                                              :class="['input-memo', {'input-error': errors.has('commentBody' + c, 'editForm')}]"></textarea>
                                </template>
                            </div>
                            <div class="comment-actions">
                                <div class="btns" v-if="!comment.Edited">
                                    <button type="button" class="btn btn-img"
                                            v-if="comment.Deleted !== true && ((comment.UserId === info.User.Id && comment.CanBeEdited) || info.User.MainRole === 'administrators')"
                                            @click="onCommentEdit(comment)">
                                        <img src="../../../img/pencil-edit-button.png" alt="" />
                                    </button>
                                    <button type="button" class="btn btn-img"
                                            v-if="comment.Deleted !== true"
                                            @click="onCommentDelete(comment.Id)">
                                        <img src="../../../img/icon-del.png" alt="" />
                                    </button>
                                </div>
                                <div class="btns" v-else>
                                    <button type="button" class="btn"
                                            @click="onCommentSave(comment)">
                                        Сохранить
                                    </button>
                                    <button type="button" class="btn"
                                            @click="onCommentCancel(comment)">
                                        Отмена
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="body-panel-control">
                    <div class="flex comment-add">
                        <textarea name="comment" rows="3" placeholder="Ваш комментарий"
                                  data-vv-scope="addForm"
                                  v-validate="'required'"
                                  v-model="commentBody"
                                  :class="['input-memo', {'input-error': errors.has('comment', 'addForm')}]"></textarea>
                        <div class="btns">
                            <button class="btn" @click="onCommentSave(null)">
                                <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <use xlink:href="/Content/dist/image_svg.svg?#Send"></use>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </template>

        <popup-window ref="ppUsers" :title="'Пользователи, просмотревшие новость'" :width="800" @onBottomScrolled="onBottomScrolledUsers">
            <button class="btn" type="button" @click="onExport()" style="margin: 0 0 10px auto;">Экспорт</button>
            <table class="t-data" style="max-width:1000px;margin:0 auto">
                <thead>
                    <tr class="heading">
                        <th class="with-img mob-hide">Пользователь</th>
                        <th class="w150-r">Дата просмотра</th>
                        <th class="w150-r">Дата лайка</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="item of users.data">
                        <tr :class="['hide-when-not-mob']">
                            <td class="number">
                                <img v-if="item.UserImage !== null" :src="item.UserImage" />
                                <img v-else src="../../../img/u57.png" />
                            </td>
                            <td class="with-img">
                                <span>{{ item.UserFio }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="with-img mob-hide">
                                <img v-if="item.UserImage !== null" :src="item.UserImage" />
                                <img v-else src="../../../img/u57.png" />
                                <span>{{ item.UserFio }}</span>
                            </td>
                            <td class="w150-r" style="text-align:center">{{ formatDateLong(item.ViewedDate) }}</td>
                            <td class="w150-r" style="text-align:center">{{ formatDateLong(item.LikedDate) }}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </popup-window>

        <vue-headful title="Новости" />
    </div>
</template>

<script>
    import BackendApi from '../../backendApi'
    import UI from '../../helpers/ui-helpers'
    import config from '../../config'
    import _ from 'lodash'

    let backendApi = new BackendApi();

    export default {
        name: "news-details",

        props: ['info'],

        data() {
            return {
                news: null,
                commentBody: null,
                comments: {
                    data: [],
                    page: 1,
                    loading: false,
                    canBeLoaded: true
                },
                users: {
                    data: [],
                    page: 1,
                    loading: false,
                    canBeLoaded: true
                },
                commentShow: false,
                showWhoLiked: false
            }
        },

        computed: {
            // todo remove computed?
            BodyFormatted: function (){
                if (this.news != null) {
                    let body = this.news.Body.replace(/\n/g, '<br>');
                    return body; //UI.format_text_helper(body);
                }
            }
        },

        methods: {
            cancel() {
                this.$router.back();
            },

            formatBody(body){
                return body ? body.replace(/\n/g, '<br>') : null;
            },

            onEditNews(){
                this.$router.push('/news/edit/' + this.news.Id);
            },

            loadNews() {
                let that = this;
                let id = parseInt(this.$route.params.id);
                return this.callApiWrapper(backendApi.newsLoad(id)).then(function (response) {
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при загрузке новости');
                    }
                    else {
                        if(response.data == null)
                        {
                            that.$router.push('/news');
                        }
                        else {
                            that.news = response.data;

                            if(response.data.CommentsEnabled && that.$route.query.comments !== undefined){
                                that.onShowComments();
                            }
                        }
                    }
                })
            },

            onShowComments() {
                let vm = this;
                this.commentShow = !this.commentShow;
                if (this.commentShow) {
                    vm.reloadComments();
                }
            },

            onMakeMark() {
                let vm = this;
                backendApi.newsMakeVote(this.news.Id).then(function (response) {
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при выполнении запроса. Попробуйте позже');
                    } else {
                        vm.news.MyVote = !vm.news.MyVote;
                    }
                });
            },

            onMarkEnter: _.debounce(function () {
                this.showWhoLiked = true;
            }, 300),

            onMarkLeave(){
                this.showWhoLiked = false;
            },

            onShowUsers() {
                if (this.info.User.MainRole !== 'administrators')
                    return;

                this.$nextTick(() => {

                    this.users.data = [];
                    this.users.page = 1;
                    this.users.canBeLoaded = true;
                    this.users.loading = false;
                    this.loadNextUsers();
                    this.$refs['ppUsers'].show();

                });
            },

            loadNextUsers() {
                let vm = this;

                vm.users.loading = true;
                UI.blockUI('.popup', 'Загрузка...');
                this.callApiWrapper(backendApi.newsUsersList((this.users.page - 1) * 20, 20, this.news.Id))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки лайков');
                        }
                        else {
                            if (resp.data && resp.data.length) {
                                vm.users.data.push(...resp.data);
                            }
                            else {
                                vm.users.canBeLoaded = false;
                            }
                        }
                        UI.unblockUI('.popup');
                        vm.users.loading = false;
                    })
            },

            onExport(){
                let vm = this;

                UI.blockUI('#app');
                vm.callApiWrapper(backendApi.newsExportUsers(vm.news.Id))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время экспорта');
                        }
                        else {
                            let exportFile = resp.data;
                            if (exportFile != null) {
                                UI.downloadFileByBytes(exportFile, 'Пользователи, просмотревшие новость.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                            }
                        }
                        UI.unblockUI('#app');
                    });
            },

            onBottomScrolledUsers() {
                let vm = this;

                if (!vm.users.loading && vm.users.canBeLoaded) {
                    vm.users.page++;
                    vm.loadNextUsers();
                }
            },

            loadNextComments(){
                let vm = this;

                vm.comments.loading = true;
                UI.blockUI('.comments', 'Загрузка...');
                this.callApiWrapper(backendApi.commentsList((this.comments.page - 1) * 8, 8, this.news.Id))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки комментариев');
                        }
                        else {
                            if (resp.data && resp.data.length) {
                                //let comments = [];
                                for (let item of resp.data) {
                                    //item.BodyFormatted = item.Body ? item.Body.replace(/\n/g, '<br>') : null;
                                    item.BodyOrigin = item.Body;
                                    item.Edited = false;
                                }
                                vm.comments.data.unshift(...resp.data);

                                vm.$nextTick(() => {
                                    $('#CommentsBody').scrollTop($('#CommentsBody').outerHeight());
                                });
                            }
                            else {
                                vm.comments.canBeLoaded = false;
                            }

                        }
                        UI.unblockUI('.comments');
                        vm.comments.loading = false;
                    })

               
            },

            onCommentSave(comment){
                let vm = this;
                let scope = comment == null ? 'addForm': 'editForm';
                this.$validator.validateAll(scope).then(result => {
                    if (!result) {
                        UI.toastr.error('Проверьте введённые данные');
                    }
                    else {
                        UI.blockUI('.dataContent', 'Сохранение...');
                        if (comment == null) {
                            comment = {
                                NewsId: vm.news.Id,
                                Body: vm.commentBody
                            }
                        }
                        backendApi.commentSave(comment).then(function (response) {
                            UI.unblockUI('.dataContent');
                            if (response.hasError) {
                                if(response.status === 203){
                                    UI.toastr.error('Комментарий доступен только для удаления');
                                }
                                else{
                                    UI.toastr.error('Ошибка при сохранении комментария');
                                }
                            } else {
                                UI.toastr.success('Успешно сохранено');
                                vm.reloadComments();
                            }
                        });
                    }
                });
            },

            onCommentCancel(comment){
                comment.Body = comment.BodyOrigin;
                comment.Edited = false;
            },

            onCommentDelete(id){
                let vm = this;

                if (confirm('Вы уверены?')) {
                    UI.blockUI('.dataContent', 'Удаление...');
                    backendApi.commentDelete(id).then(function (response) {
                        UI.unblockUI('.dataContent');
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при удалении комментария');
                        } else {
                            UI.toastr.success('Успешно удалено');

                            vm.reloadComments();
                        }
                    });
                }
            },

            onCommentEdit(comment){
                for(let c of this.comments.data){
                    c.Body = c.BodyOrigin;
                    c.Edited = false;
                }
                comment.Edited = true;
            },

            reloadComments(){
                this.comments.page = 1;
                this.comments.canBeLoaded = true;
                this.comments.data = [];
                this.commentBody = null;
                this.loadNextComments();

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },

            onScrollComments(e) {
                let vm = this;
                if (!vm.comments.loading && vm.comments.canBeLoaded) {
                    let elem = $(e.target);
                    if (elem.scrollTop() < 100) {
                        vm.comments.page++;
                        vm.loadNextComments();
                    }
                }
            },
        },

        mounted() {
            let vm = this;
            UI.blockUI('.page-content', 'Загрузка...');
            this.loadNews().then(() => {
                UI.unblockUI('.page-content');
                vm.$emit('user-updated');
            });
        },

        destroyed() {
            
        }
    }
</script>

<style scoped>
    .news-actions.like{
        position: relative;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>


// WEBPACK FOOTER //
// Content/src/views/details/NewsDetails.vue